import Footer from "../component/Footer";
import Header from "../component/Header";
import setting from '../setting.json';

const Committee = () => {
    return (
        <>
            <Header />

            <section className="page-header bg_img"
                style={{
                    backgroundImage: "URL(./images/banner2.jpg)",
                    height: "30lvh",
                }}
            >
                <div className="container">
                    <div className="page-header-content">
                        <h1 className="title">Anti Discrimination Cell</h1>
                        <ul className="breadcrumb">
                            <li>
                                <a href="/">Home</a>
                            </li>
                            <li> Anti Discrimination Cell </li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="faqs-single-section padding-top padding-bottom">
                <div className="container">
                    <div className="row ">
                        <div className="col-lg-12">

                            <embed src={`${setting.api}uploads/docs/anti_discrimination_cell.pdf#toolbar=0&navpanes=0&scrollbar=0&view=fitH,100`} type="application/pdf" frameBorder="0" scrolling="auto" height="2100px" width="100%">
                            </embed>

                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
}

export default Committee;